module.exports = __webpack_public_path__ + "img/wordcloud.9a431a8a.png";